import React from "react";

export default function GameTypeIcon({ type }) {
  switch (type) {
    case "single-digit":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="9" y="5" width="24" height="32" rx="4" stroke="#F5C443" strokeWidth="2" />
          <circle cx="21" cy="21" r="5.5" stroke="#F5C443" strokeWidth="2" />
        </svg>
      );
    case "jodi-digit":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="11" y="6" width="20" height="30" rx="3.5" stroke="#F5C443" strokeWidth="2" />
          <circle cx="21" cy="14" r="2.5" fill="#F5C443" />
          <circle cx="21" cy="28" r="2.5" fill="#F5C443" />
        </svg>
      );
    case "single-pana":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="10" y="7" width="22" height="28" rx="4" stroke="#F5C443" strokeWidth="2" />
        </svg>
      );
    case "double-pana":
    case "sp-dp-tp":
    case "digit-based-jodi":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="9" y="10" width="18" height="25" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(-12 9 10)" />
          <rect x="16" y="8" width="18" height="25" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(8 16 8)" />
        </svg>
      );
    case "triple-pana":
    case "tripple-pana":
    case "triple-panna":
    case "tripple-panna":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="6" y="11" width="16" height="23" rx="2.5" stroke="#F5C443" strokeWidth="1.5" transform="rotate(-18 6 11)" />
          <rect x="13" y="9" width="16" height="23" rx="2.5" stroke="#F5C443" strokeWidth="1.5" />
          <rect x="20" y="7" width="16" height="23" rx="2.5" stroke="#F5C443" strokeWidth="1.5" transform="rotate(18 20 7)" />
        </svg>
      );
    case "sp-motor":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="9" y="9" width="24" height="24" rx="4" stroke="#F5C443" strokeWidth="2" />
        </svg>
      );
    case "dp-motor":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="13" stroke="#F5C443" strokeWidth="2.5" />
          <circle cx="21" cy="21" r="6" stroke="#F5C443" strokeWidth="2" />
          <line x1="21" y1="8" x2="21" y2="15" stroke="#F5C443" strokeWidth="2.5" />
          <line x1="21" y1="27" x2="21" y2="34" stroke="#F5C443" strokeWidth="2.5" />
          <line x1="8" y1="21" x2="15" y2="21" stroke="#F5C443" strokeWidth="2.5" />
          <line x1="27" y1="21" x2="34" y2="21" stroke="#F5C443" strokeWidth="2.5" />
        </svg>
      );
    case "group-jodi":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 18C17 18 13 12 17 8C21 12 17 18 17 18Z" fill="#F5C443" />
          <path d="M16 17H18V21H16V17Z" fill="#F5C443" />
          <path d="M27 24C27 24 24 20 27 17C30 20 27 24 27 24Z" fill="#F5C443" />
          <path d="M26 23H28V26H26V23Z" fill="#F5C443" />
        </svg>
      );
    case "odd-even":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="11" y="9" width="16" height="16" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(-15 11 9)" />
          <rect x="19" y="15" width="16" height="16" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(15 19 15)" />
        </svg>
      );
    case "red-bracket":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25 11C20 11 18 13 18 18C18 20 16 21 14 21C16 21 18 22 18 24C18 29 20 31 25 31" stroke="#F5C443" strokeWidth="3" strokeLinecap="round" />
        </svg>
      );
    case "choice-pana":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" y="12" width="16" height="23" rx="3" stroke="#F5C443" strokeWidth="1.6" transform="rotate(-20 7 12)" />
          <rect x="13" y="8" width="16" height="23" rx="3" stroke="#F5C443" strokeWidth="1.6" />
          <rect x="19" y="8" width="16" height="23" rx="3" stroke="#F5C443" strokeWidth="1.6" transform="rotate(20 19 8)" />
        </svg>
      );
    case "panel-group":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="10.5" fill="#F5C443" />
        </svg>
      );
    case "two-digit-panel":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="11" y="6" width="20" height="30" rx="3.5" stroke="#F5C443" strokeWidth="2" />
          <circle cx="21" cy="14" r="2.5" stroke="#F5C443" strokeWidth="1.5" />
          <circle cx="21" cy="28" r="2.5" stroke="#F5C443" strokeWidth="1.5" />
        </svg>
      );
    case "half-sangam-a":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" y="8" width="16" height="26" rx="3" stroke="#F5C443" strokeWidth="1.8" />
          <circle cx="30" cy="21" r="6.5" stroke="#F5C443" strokeWidth="1.8" />
          <text x="15" y="25" fill="#F5C443" fontSize="11" fontWeight="800" textAnchor="middle" fontFamily="sans-serif">A</text>
        </svg>
      );
    case "half-sangam-b":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="21" r="6.5" stroke="#F5C443" strokeWidth="1.8" />
          <rect x="19" y="8" width="16" height="26" rx="3" stroke="#F5C443" strokeWidth="1.8" />
          <text x="27" y="25" fill="#F5C443" fontSize="11" fontWeight="800" textAnchor="middle" fontFamily="sans-serif">B</text>
        </svg>
      );
    case "full-sangam":
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" y="10" width="16" height="24" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(-10 7 10)" />
          <rect x="19" y="8" width="16" height="24" rx="3" stroke="#F5C443" strokeWidth="1.8" transform="rotate(10 19 8)" />
          <circle cx="21" cy="21" r="3" fill="#F5C443" />
        </svg>
      );
    default:
      return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="10" y="7" width="22" height="28" rx="4" stroke="#F5C443" strokeWidth="2" />
        </svg>
      );
  }
}
